export default "__VITE_ASSET__mm3FVwk1__"